// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"440":"d340b532","839":"899905a5"}[chunkId] + ".chunk.js";
};